var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatKing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 206,
    viewBox: "0 0 190 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7035 127.94C0.51049 79.2436 12.9115 55 12.9115 55C12.9115 55 50.51 55.5584 64.0976 74.0785",
    fill: "#D0D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7035 127.94C0.51049 79.2436 12.9115 55 12.9115 55C12.9115 55 50.51 55.5584 64.0976 74.0785",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.472 127.94C186.642 79.2436 174.241 55 174.241 55C174.241 55 136.666 55.5584 123.055 74.0785",
    fill: "#D0D0D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.472 127.94C186.642 79.2436 174.241 55 174.241 55C174.241 55 136.666 55.5584 123.055 74.0785",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9662 109.607C18.4279 85.4561 24.5935 73.4041 24.5935 73.4041C24.5935 73.4041 43.2066 73.6833 49.9539 82.8735",
    fill: "#E06BA3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9662 109.607C18.4279 85.4561 24.5935 73.4041 24.5935 73.4041C24.5935 73.4041 43.2066 73.6833 49.9539 82.8735",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.213 109.607C168.752 85.4561 162.586 73.4041 162.586 73.4041C162.586 73.4041 143.973 73.6833 137.226 82.8735",
    fill: "#E06BA3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.213 109.607C168.752 85.4561 162.586 73.4041 162.586 73.4041C162.586 73.4041 143.973 73.6833 137.226 82.8735",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1817 204.324C111.53 204.88 128.761 201.283 144.437 193.831C155.209 188.573 167.704 181.616 171.449 168.703C173.081 162.23 172.831 155.426 170.728 149.09C171.1 145.646 180.314 112.259 146.089 83.9439C131.655 71.8666 113.242 65.5962 94.4376 66.3545H94.1817C75.3846 65.5998 56.9799 71.8701 42.5535 83.9439C8.32858 112.282 17.5421 145.67 17.9143 149.09C15.8129 155.425 15.5547 162.227 17.1698 168.703C20.9157 181.616 33.4563 188.573 44.2054 193.831C59.8526 201.272 77.0501 204.869 94.3678 204.324H94.1817Z",
    fill: "#D0D0D0",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5614 155.837C63.0248 155.837 68.2644 150.431 68.2644 143.762C68.2644 137.093 63.0248 131.687 56.5614 131.687C50.098 131.687 44.8584 137.093 44.8584 143.762C44.8584 150.431 50.098 155.837 56.5614 155.837Z",
    fill: "#1D1D1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1139 164.957C51.1744 164.957 54.4661 163.103 54.4661 160.816C54.4661 158.528 51.1744 156.674 47.1139 156.674C43.0534 156.674 39.7617 158.528 39.7617 160.816C39.7617 163.103 43.0534 164.957 47.1139 164.957Z",
    fill: "#E06BA3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.733 155.837C138.197 155.837 143.436 150.431 143.436 143.762C143.436 137.093 138.197 131.687 131.733 131.687C125.27 131.687 120.03 137.093 120.03 143.762C120.03 150.431 125.27 155.837 131.733 155.837Z",
    fill: "#1D1D1B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.181 164.957C145.242 164.957 148.533 163.103 148.533 160.816C148.533 158.528 145.242 156.674 141.181 156.674C137.121 156.674 133.829 158.528 133.829 160.816C133.829 163.103 137.121 164.957 141.181 164.957Z",
    fill: "#E06BA3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.349 162.398C102.349 165.096 94.0196 168.866 94.0196 168.866C94.0196 168.866 85.667 165.166 85.667 162.398C85.667 159.629 89.4129 157.535 94.0196 157.535C98.6264 157.535 102.349 159.722 102.349 162.398Z",
    fill: "#1D1D1B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0219 141.062C53.1655 141.062 54.0926 140.104 54.0926 138.922C54.0926 137.74 53.1655 136.781 52.0219 136.781C50.8783 136.781 49.9512 137.74 49.9512 138.922C49.9512 140.104 50.8783 141.062 52.0219 141.062Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.163 157.163L188.619 154.534",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.163 165.865L188.619 168.494",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.071 161.514H177.429",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.847 141.062C127.991 141.062 128.918 140.104 128.918 138.922C128.918 137.74 127.991 136.781 126.847 136.781C125.703 136.781 124.776 137.74 124.776 138.922C124.776 140.104 125.703 141.062 126.847 141.062Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4795 157.163L1 154.534",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4795 165.865L1 168.494",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.572 161.514H12.2139",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0186 204.324C111.336 204.869 128.534 201.272 144.181 193.831C154.953 188.573 167.447 181.616 171.217 168.703C172.832 162.227 172.573 155.425 170.472 149.09C170.844 145.646 180.058 112.259 145.833 83.9439C131.407 71.8701 113.002 65.5998 94.2047 66.3545H94.0186C75.214 65.5962 56.8007 71.8666 42.3672 83.9439C8.14228 112.282 17.3558 145.67 17.728 149.09C15.6254 155.426 15.3751 162.23 17.0068 168.703C20.7294 181.616 33.2933 188.573 44.0191 193.831C59.6745 201.272 76.8796 204.869 94.2047 204.324H94.0186Z",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0187 168.866C90.6331 171.993 86.1543 173.664 81.5479 173.519",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1123 168.866C97.4867 171.996 101.96 173.668 106.56 173.519",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M119.355 125.148C122.643 122.713 126.65 121.447 130.74 121.553C134.829 121.658 138.766 123.128 141.924 125.729",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7168 124.938C46.3129 122.185 50.6986 120.66 55.227 120.589C59.7554 120.518 64.1869 121.904 67.8678 124.543",
    stroke: "#1D1D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.96 76.3152C71.7771 53.7289 59.4466 23.4546 51.5279 13.345C51.3105 13.0675 51.5993 12.6633 51.9321 12.7792C70.6376 19.2948 77.7132 28.4493 81.809 37.3595C81.9436 37.6524 82.3731 37.6239 82.464 37.3146L93.1072 1.12763C93.2046 0.796753 93.6732 0.796756 93.7705 1.12763L104.433 37.3795C104.521 37.6807 104.937 37.7208 105.087 37.4451C110.805 26.956 125.149 18.1697 135.03 12.9563C135.341 12.7917 135.675 13.1446 135.493 13.4472C125.122 30.7672 118.907 62.373 117.058 76.3609C117.05 76.418 117.029 76.4692 116.995 76.5157C107.975 88.7773 81.2002 88.7873 71.0382 76.5456C70.9843 76.4807 70.9569 76.3995 70.96 76.3152Z",
    fill: "#E4C580",
    stroke: "black",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.748 52.8063C104.292 53.2711 104.494 54.0234 104.255 54.6981L100.534 65.1997C100.275 65.9312 99.5599 66.4003 98.7857 66.3468L88.1353 65.6114C87.3988 65.5605 86.7758 65.0475 86.5847 64.3343L83.6271 53.2962C83.436 52.583 83.7189 51.8272 84.3314 51.4149L93.1872 45.4528C93.8309 45.0194 94.6846 45.0682 95.2749 45.5721L103.748 52.8063Z",
    fill: "#D90000",
    stroke: "black",
    strokeWidth: 1.72852
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatKing);
export default __webpack_public_path__ + "static/media/catKing.9018e20324292222281e9d9166c1922c.svg";
export { ForwardRef as ReactComponent };